import { withMotionMax } from '@hoc/withMotionMax';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import SvgBolt from '@img/icons/bolt.svg';
import SvgChevronLeft from '@img/icons/chevron-left.svg';
import SvgChevronRight from '@img/icons/chevron-right.svg';
import SvgClose from '@img/icons/close.svg';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Carousels/Carousel/Connected/Connected';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import Cookies from 'universal-cookie';
import S from './NewsFlashBanner.styles';
const NewsFlashBanner = (props) => {
    const cookies = new Cookies();
    const hasCookie = cookies.get('newsBanner');
    const [isShowing, setIsShowing] = React.useState(hasCookie === 'hide' ? false : true);
    React.useEffect(() => {
        setIsShowing(hasCookie === 'hide' ? false : true);
    }, [hasCookie]);
    return (React.createElement(MotionConfig, { transition: { duration: 0.35, ease: 'easeOut' } }, isShowing ? (React.createElement(React.Fragment, null,
        React.createElement(CarouselProvider, { paddingOffset: 0, count: props.items.length, variable: true },
            React.createElement(S.Container, { "data-is-showing": isShowing },
                React.createElement(S.Inner, null,
                    React.createElement(Connected, null, (carousel) => (React.createElement(S.Pagination, null,
                        React.createElement(S.PaginationButton, { disabled: carousel.activeIndex === 0, onClick: (event) => {
                                event.preventDefault();
                                carousel.goToPrev(true);
                            }, "aria-label": "Previous item" },
                            React.createElement(SvgChevronLeft, null)),
                        React.createElement(S.Counter, null,
                            carousel.activeIndex + 1,
                            " / ",
                            carousel.maxIndex + 1),
                        React.createElement(S.PaginationButton, { disabled: carousel.activeIndex === carousel.maxIndex, onClick: (event) => {
                                event.preventDefault();
                                carousel.goToNext(true);
                            }, "aria-label": "Next item" },
                            React.createElement(SvgChevronRight, null))))),
                    React.createElement(S.Title, null,
                        React.createElement(SvgBolt, null),
                        React.createElement("span", null, props.title)),
                    React.createElement(S.CarouselWrapper, null,
                        React.createElement(MotionTrack, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                            React.createElement(S.ItemTitle, null, item.title),
                            React.createElement(S.ItemTitleShort, null, item.titleShort),
                            React.createElement(S.ItemLink, { href: item.url, "aria-label": `${item.title} - Read more` },
                                React.createElement(S.ItemLinkText, null, "Read more"),
                                React.createElement(S.ItemLinkIcon, { as: SvgArrowRight }))))))),
                    React.createElement(S.Close, { type: "button", title: "close", onClick: () => {
                            cookies.set('newsBanner', 'hide', { path: '/' });
                            setIsShowing(false);
                        } },
                        React.createElement(SvgClose, null))))),
        React.createElement(S.GlobalStyles, null))) : (React.createElement(S.GlobalStylesNoBanner, null))));
};
export default withMotionMax(NewsFlashBanner);
